import {useSearchParams} from 'react-router-dom';

// A screen reached from a form carries `?return=<path>` so it can offer "Back to your tell".
// Only in-app paths are honoured.
export function useReturnTo(): string | null {
    const [params] = useSearchParams();
    const value = params.get('return');
    return value && value.startsWith('/') && !value.startsWith('//') ? value : null;
}

export const withReturn = (path: string, returnTo: string | null | undefined): string =>
    returnTo ? `${path}?return=${encodeURIComponent(returnTo)}` : path;
